<app-form-modal-dialog
    #modal
    [submit]="form.submit.bind(form)"
>
    <div title>
        Vestiging toevoegen
    </div>
    <div body>
        <app-establishment-form
            #form
            (submitted)="createEstablishment($event)"
        />
    </div>
    <div button-submit>
        Vestiging toevoegen
    </div>
</app-form-modal-dialog>
